module.exports = __webpack_public_path__ + "media/category_icons/FamilyMedicine-db73a8fb.svg";